export default __webpack_public_path__ + "static/media/six-network.917ae94a.png";